import $ from 'jquery';

$(document).on("click", ".toggle-search", function () {
    $("#NavSearchToggle").toggleClass("search");
    $("#buscar_nav").slideToggle(150);
});
